import { Alert, Descriptions, Select, Space, Typography } from 'antd';
import { Link } from 'react-router-dom';
import E2ERun, { E2EAttempt } from '../../../domain/models/E2ERun';
import E2EStatus from './E2EStatus';
import { E2E_RESULTS_PAGE_PATH } from './E2EResultsPage';

type Props = {
  run: E2ERun;
  attempt: E2EAttempt;
  onSelect: (value: number) => void;
};
export default function E2ERunOverview({ run, attempt, onSelect }: Props) {
  return (
    <>
      <Space wrap style={{ marginBottom: 16 }}>
        <Select
          aria-label="Tentative GitHub"
          value={attempt.runAttempt}
          onChange={onSelect}
          options={run.attempts.map((a) => ({
            value: a.runAttempt,
            label: `Tentative GitHub ${a.runAttempt}`,
          }))}
        />
        <a href={run.githubUrl} target="_blank" rel="noreferrer">
          Run GitHub
        </a>
      </Space>
      <Descriptions
        bordered
        column={{ xs: 1, md: 2 }}
        items={[
          {
            key: 'source',
            label: 'Source testée',
            children: (
              <>
                {attempt.branch} · <Typography.Text code>{attempt.commit}</Typography.Text>
              </>
            ),
          },
          {
            key: 'profile',
            label: 'Environnement',
            children: `${attempt.environment} · ${attempt.profile}`,
          },
          {
            key: 'apk',
            label: 'APK',
            children: (
              <>
                <E2EStatus status={attempt.apk.conclusion ?? attempt.apk.status} />
                {attempt.apk.reason}
                <div>{attempt.apk.buildId && `Build ${attempt.apk.buildId}`}</div>
                <div>
                  {attempt.apk.expoWorkflowId && `Workflow Expo ${attempt.apk.expoWorkflowId}`}
                </div>
              </>
            ),
          },
          {
            key: 'e2e',
            label: 'E2E',
            children: (
              <>
                <E2EStatus status={attempt.tests.conclusion ?? attempt.tests.status} />
                {attempt.tests.reason}
              </>
            ),
          },
          {
            key: 'report',
            label: 'Rapport',
            children: <E2EStatus status={attempt.reportAvailability} />,
          },
          {
            key: 'counts',
            label: 'Parcours produit',
            children: `${attempt.counters.passed} réussis · ${attempt.counters.failed} échoués · ${attempt.counters.notRun} non exécutés`,
          },
          {
            key: 'date',
            label: 'Dernière publication',
            children: new Date(attempt.publishedAt).toLocaleString(),
          },
          ...(attempt.apk.preparationRunId
            ? [
                {
                  key: 'preparation',
                  label: 'Préparation APK',
                  children: (
                    <Link
                      to={`${E2E_RESULTS_PAGE_PATH}/leedgroup_leedpulse-monorepo_${attempt.apk.preparationRunId}`}
                    >
                      Run #{attempt.apk.preparationRunId}
                    </Link>
                  ),
                },
              ]
            : []),
        ]}
      />
      {run.continuationRunId && (
        <Alert
          style={{ marginTop: 16 }}
          type="info"
          message={
            <Link
              to={`${E2E_RESULTS_PAGE_PATH}/leedgroup_leedpulse-monorepo_${run.continuationRunId}`}
            >
              Validation E2E poursuivie dans le run #{run.continuationRunId}
            </Link>
          }
        />
      )}
    </>
  );
}
